import script from "./Elementary.vue?vue&type=script&setup=true&lang=ts"
export * from "./Elementary.vue?vue&type=script&setup=true&lang=ts"

import "./Elementary.vue?vue&type=style&index=0&id=16ac07a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ac07a6"]])

export default __exports__